package Utils

import kotlinx.serialization.Serializable
import myName


@myName("TaxHolder")
@Serializable
data class TaxHolder(val percent: Float,val multi_tax:Float, val date: String,val tax_israel_limit:Float=25000f) {
}